import React, {Component} from 'react';
import {ResponsiveContainer, BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip} from 'recharts';

import BarLabel from './bar_label';

import graphData from './engagement_rate_graph_info';

export default class EngagementRateGraph extends Component {
    constructor(){
        super();
        this.renderCells = this.renderCells.bind(this);
    }

    componentDidMount(){
        const {handleRenderTooltip} = this.props;

        setTimeout(()=> {
            handleRenderTooltip();
        }, 2500);
    }

    renderCells(){
        const {handleRenderTooltip} = this.props;
        const colors = ['#4ED2C4', '#FEA410', '#00A1E1'];

        return graphData.map((entry, idx) => {
            return <Cell key={`cell-${idx}`} fill={colors[idx]} />
        });
    }

    render(){
        const {setTooltipPosition} = this.props;
        const cells = this.renderCells();

        return(
            <ResponsiveContainer
                width={'80%'}
                height={'65%'}>
                <BarChart
                    data={graphData}
                    barSize={150}>
                    <YAxis
                        orientation='right'
                        axisLine={false}
                        domain={[0, 6]}
                        tickLine={false}
                        tickFormatter={(val) => { return `${val}%` }}
                        ticks={[1.5, 3, 4.5, 6]} />
                    <CartesianGrid
                        vertical={false}
                        strokeDasharray="3 3" />
                    <Bar
                        animationBeing={500}
                        animationDuration={2000}
                        dataKey='engagementRate'
                        label={<BarLabel setTooltipPosition={setTooltipPosition} />}
                        onClick={this.handleClick}>
                        {cells}
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        );
    }
}



// WEBPACK FOOTER //
// ./web/js/components/brand_ambassadors/engagement_rate_graph/index.js